var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-app",class:{ 'c-dark-theme': _vm.$store.state.darkMode }},[_c('TheSidebar'),_c('CWrapper',[_c('TheHeader',{attrs:{"breadcrumbs":_vm.breadcrumbs,"page-title":_vm.pageTitle}}),_c('div',{ref:"c-body",class:[
				'c-body',
				_vm.cBodyClass
			],on:{"scroll":_vm.handleScroll}},[_c('main',{staticClass:"c-main"},[_c('CContainer',{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }